import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Customer/public API — uses cookies via withCredentials
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach session token as Bearer header when available (needed for local dev
// where cross-port cookie restrictions block httpOnly cookies from the backend)
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("bcp_session_token");
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

// Admin API — Bearer token from localStorage
export const adminApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

adminApi.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("bcp_admin_token");
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

export function formatAud(n) {
  const value = Number(n) || 0;
  return new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(value);
}